import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './query-provider';
import { ThemeProvider } from './theme-provider';

/** Agrupa todos os providers globais da aplicacao. */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <QueryProvider>{children}</QueryProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export { QueryProvider } from './query-provider';
export { ThemeProvider, useTheme } from './theme-provider';
